import { gql, useQuery, type ErrorPolicy, type WatchQueryFetchPolicy } from '@apollo/client';

import { NexoyaQuery, NexoyaQueryPortfoliosArgs } from '../../types/types';
import { NexoyaSearchFilter, NexoyaSortBy } from 'types';

import { useTeam } from '../../context/TeamProvider';

import { separateLoading } from '../../utils/graphql';

import { PAGE_INFO_FRAGMENT } from '../fragments';
import { PORTFOLIO_2_DATES_FRAGMENT, PORTFOLIO_2_META_FRAGMENT } from './fragments';

const PORTFOLIOS_QUERY = gql`
  query Portfolios($teamId: Int!, $offset: Int, $first: Int, $after: String, $where: SearchFilter, $sortBy: SortBy) {
    portfolios(teamId: $teamId, offset: $offset, first: $first, after: $after, where: $where, sortBy: $sortBy) {
      edges {
        node {
          createdByUserId
          ...portfolioDates
          ...portfolioMeta
        }
        cursor
      }
      pageInfo {
        ...pageInfo
      }
    }
  }
  ${PORTFOLIO_2_DATES_FRAGMENT}
  ${PORTFOLIO_2_META_FRAGMENT}
  ${PAGE_INFO_FRAGMENT}
`;
// teamId: Int!, offset: Int, first: Int, after: String, where: SearchFilter, sortBy: SortBy
type Options = {
  offset?: number | null;
  first?: number | null;
  after?: string | null;
  where?: NexoyaSearchFilter | null;
  sortBy?: NexoyaSortBy | null; // TODO: add correct type
  onCompleted?: (data: any) => void;
  skip?: boolean;
  fetchPolicy?: WatchQueryFetchPolicy;
  errorPolicy?: ErrorPolicy;
  context?: Record<string, unknown>;
};

function usePortfoliosQuery({
  offset = null,
  first = 50,
  after = null,
  where = null,
  sortBy = null,
  onCompleted,
  skip = false,
  fetchPolicy,
  errorPolicy,
  context,
}: Options = {}): any {
  const { teamId } = useTeam();
  const query = useQuery<Pick<NexoyaQuery, 'portfolios'>, NexoyaQueryPortfoliosArgs>(PORTFOLIOS_QUERY, {
    // `teamId: Int!` is required and is 0 until TeamProvider settles, which the gateway rejects.
    skip: skip || !teamId,
    notifyOnNetworkStatusChange: true,
    fetchPolicy,
    errorPolicy,
    context,
    variables: {
      teamId,
      offset,
      first,
      after,
      where,
      sortBy,
    },
    onCompleted,
  });
  return { ...separateLoading(query) };
}

export { PORTFOLIOS_QUERY, usePortfoliosQuery };
